// import Slider from "react-slick";
// import "slick-carousel/slick/slick-theme.css";
// import "slick-carousel/slick/slick.css";
// import "./PlantationTwoCategories.scss";
// import PGLoaders from "../../../../default-pages/PGLoaders/PGLoaders";

// import { useNavigate } from "react-router-dom";
// import { useCollection } from "../../../../firebase-files/hooks/useCollection";

// const PlantationTwoCategories = () => {
  
//   const { documents, error } = useCollection("m_categories", [
//     "category",
//     "==",
//     "Curated Collections",
//   ]);
//   const navigate = useNavigate();

//   // Filter active categories only after fetching
//   const categories = documents
//     ? documents.filter((doc) => doc.status === "active").slice(0, 12)
//     : [];

//   const sliderSettings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 1500,
//     arrows: true,
//     responsive: [
//       { breakpoint: 1280, settings: { slidesToShow: 3 } },
//       { breakpoint: 1024, settings: { slidesToShow: 3 } },
//       { breakpoint: 992, settings: { slidesToShow: 4 } },
//       { breakpoint: 912, settings: { slidesToShow: 3 } },
//       { breakpoint: 820, settings: { slidesToShow: 3 } },
//       { breakpoint: 768, settings: { slidesToShow: 3 } },
//       { breakpoint: 576, settings: { slidesToShow: 2 } },
//       { breakpoint: 480, settings: { slidesToShow: 2 } },
//     ],
//   };

//   if (error) return <p>Error: {error}</p>;
//   if (!documents) return <p><PGLoaders/></p>;

//   return (
//     <div className="eco-categories-wrapper">
//       <h2 className="eco-heading">Curated Collections</h2>
//       <Slider {...sliderSettings}>
//         {categories.map((item, index) => (
//           <div
//             key={index}
//             className="eco-category-card"
//             style={{ cursor: "pointer" }}
//             onClick={() =>
//               navigate(
//                 `/products-two?category=${encodeURIComponent(item.category)}`
//               )
//             }
//           >
//             <div className="eco-icon-wrapper">
//               <img
//                 src={item.categoryImgUrl}
//                 alt={item.category}
//                 loading="lazy"
//               />
//             </div>
//             <p>{item.category}</p>
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default PlantationTwoCategories;



import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./PlantationTwoCategories.scss";
import PGLoaders from "../../../../default-pages/PGLoaders/PGLoaders";

import { useNavigate } from "react-router-dom";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const PlantationTwoCategories = () => {
  const navigate = useNavigate();

  const { documents, error } = useCollection("m_categories", [
    "category",
    "==",
    "curated collection",
  ]);

  

  if (error) return <p>Error: {error}</p>;
  if (!documents) return <PGLoaders />;

  // 🔹 Get category document
  const categoryDoc = documents[0];

  // 🔹 If category itself is inactive → don't show section
  if (!categoryDoc || categoryDoc.status !== "active") {
    return null;
  }

  // 🔹 Filter active subcategories
  const activeSubCategories = categoryDoc.subCategories
    ?.filter((sub) => sub.status === "active")
    .slice(0, 12);

  if (!activeSubCategories || activeSubCategories.length === 0) {
    return null;
  }

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: true,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div className="eco-categories-wrapper">
      <h2 className="eco-heading">Curated Collections</h2>

      <Slider {...sliderSettings}>
        {activeSubCategories.map((item, index) => (
          <div
            key={index}
            className="eco-category-card"
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(
                `/products-two?subcategory=${encodeURIComponent(
                  item.subCategoryName
                )}`
              )
            }
          >
            <div className="eco-icon-wrapper">
              <img
                src={item.subCategoryImgUrl}
                alt={item.subCategoryName}
                loading="lazy"
              />
            </div>
            <p>{item.subCategoryName}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default PlantationTwoCategories;
